import Layout2 from "@/layout/Layout2";
let ja = require("../../common/lang/ja");
let zh = require("../../common/lang/zh-CN");

export default [
  {
    path: "/points",
    component: Layout2,
    meta: {
      zhtitle: zh.m.content.member.POINT_RECORD,
      jatitle: ja.m.content.member.POINT_RECORD,
    },
    children: [
      {
        path: "",
        name: "points",
        component: () =>
          import(
            /* webpackChunkName: "jp.activitys" */ "@/merchanAdmin/points/list"
          ),
        meta: {
          zhtitle: zh.m.content.member.POINT_RECORD,
          jatitle: ja.m.content.member.POINT_RECORD,
          pername: "activity_setting",
        },
      },
    ],
  },
];
